<template>
  <div class="soi-switch-container">
    <div
      class="soi-switch"
      :class="{ 'soi-switch--active': selecionado, 'soi-switch--disabled': disabled }"
      @click="toggleSwitch"
    >
      <div class="soi-switch__track">
        <div class="soi-switch__thumb"></div>
      </div>
    </div>
    <span class="soi-switch__label" v-if="label">{{ label }}</span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.component('soi-switch', {
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    value: {
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selecionado: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.selecionado = newValue;
    },
    selecionado(newValue) {
      this.$emit('input', newValue);
    },
  },
  methods: {
    toggleSwitch() {
      if (!this.disabled) {
        this.selecionado = !this.selecionado;
      }
    },
  },
});
</script>

<style scoped>
.soi-switch-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.soi-switch {
  position: relative;
  width: 40px;
  height: 20px;
  cursor: pointer;
}

.soi-switch--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.soi-switch__track {
  width: 100%;
  height: 100%;
  background-color: var(--bg-tertiary, #e0e0e0);
  border-radius: 10px;
  position: relative;
  transition: background-color 0.3s ease;
}

.soi-switch--active .soi-switch__track {
  background-color: var(--especialidade-primary, #2e4b9d);
}

.soi-switch__thumb {
  width: 16px;
  height: 16px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.soi-switch--active .soi-switch__thumb {
  transform: translateX(20px);
}

.soi-switch__label {
  color: var(--text-secondary, #666);
  font-size: 14px;
  user-select: none;
}

/* Dark mode overrides */
.theme--dark .soi-switch__track {
  background-color: #555;
}

.theme--dark .soi-switch__label {
  color: #b0b0b0;
}
</style>
